import api from "@/libs/api";
import store from "@/store";

const initState = {
  bookShow:"",
  params:"",
};

const distribution = {
  state: initState,
  mutations: {
    SET_DIS_URL(state,url){
       state.bookShow = url
    },
    SET_DISTRIBUTION_DATA(state,proload){
      state.params = proload
   },
  },
  getters: {},
  actions: {},
};

export default distribution;



// WEBPACK FOOTER //
// ./src/store/modules/distribution.js